export const PricingWorkbenchResponseType = {
  ELIGIBLE: 'Eligible',
  PROGRAMS_LIST: 'ProgramsList',
  NOT_ELIGIBLE: 'NotEligible',
  ERROR: 'Error',
};

export const RatesPeriods = {
  PERIOD_15_DAYS: 15,
  PERIOD_30_DAYS: 30,
  PERIOD_45_DAYS: 45,
  PERIOD_60_DAYS: 60,
  PERIOD_90_DAYS: 90,
};
